<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { useWalletState } from '../../../utilities/account/useWallet'
import { formatCurrency } from '../../../utilities/helpers'
import BaseInputMoney from '../../base/BaseInputMoney.vue'

import BaseButtonSecondary from '../../base/BaseButtonSecondary.vue'
import { computed, ref } from 'vue'

const walletState = useWalletState()
const investmentProcessStore = useInvestmentProcessDataState()
const { amountToPay } = storeToRefs(investmentProcessStore)

const props = defineProps<{
    modelValue: number
}>()

const emit = defineEmits(['update:modelValue', 'close'])

const walletAmount = ref(props.modelValue)

const maxAmount = computed(() => Math.min(amountToPay.value + props.modelValue, walletState.wallet.retrievable_balance))

function confirm() {
    emit('update:modelValue', walletAmount.value)
    emit('close')
}
</script>

<template>
    <div v-if="walletState.wallet && walletState.wallet.retrievable_balance > 0" class="space-y-4">
        <div>
            <h2 class="mb-2 text-lg font-semibold">{{ $t('investment_process.wallet_amount') }}</h2>
            <p>{{ $t('investment_process.wallet_amount_description') }}</p>
        </div>

        <div>
            <BaseInputMoney
                v-model="walletAmount"
                name="wallet_amount"
                currency="EUR"
                :max="maxAmount"
                label=""
                :rules="`max:${maxAmount}`"
                size="xl" />
            <p class="mt-1 text-sm text-gray-400">
                {{ $t('investment_process.wallet_retrievable_balance') }}:
                {{ formatCurrency(walletState.wallet.retrievable_balance) }}
            </p>
        </div>
        <BaseButtonSecondary class="mt-4 w-full" size="lg" @click="confirm">{{
            $t('dialog.button.confirm')
        }}</BaseButtonSecondary>
    </div>
</template>
